import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { handleError } from '../../../utils/handle-error'
import { getTerminalInformation } from '../../../utils/terminal-webapi'

/**
 * Render Terminal Information
 */
export default class TerminalInformation extends Component {
    constructor(...args) {
        super(...args)
        this.state = {
            terminal: {},
        }
    }

    componentDidMount() {
        if (this.props.terminalInformation) {
            this.getTerminalInformation()
        }
    }

    getTerminalInformation = () => {
        getTerminalInformation(this.props.terminalInformation.id)
            .then((terminal) => {
                this.setState({ terminal })
            })
            .catch(handleError)
    }

    // eslint-disable-next-line class-methods-use-this
    value(o) {
        return o || <span className="text-muted">N/A</span>
    }

    injectionTerminal() {
        if (this.props.injectionTerminal) {
            return (
                <div>
                    <div className="strong-label">Injection Terminal</div>
                    <span className="text-muted">{this.props.injectionTerminal}</span>
                </div>
            )
        }
        return null
    }

    render() {
        const { terminal } = this.state
        return (
            <div>
                <div>
                    <div className="strong-label">Distribution Terminal</div>
                    {this.value(terminal ? terminal.name : null)}
                    {this.injectionTerminal()}
                </div>
            </div>
        )
    }
}

TerminalInformation.propTypes = {
    terminalInformation: PropTypes.object.isRequired,
    injectionTerminal: PropTypes.object,
}
